import { render, staticRenderFns } from "./PeerToPeerStatement.vue?vue&type=template&id=3e46c9de&scoped=true&"
import script from "./PeerToPeerStatement.vue?vue&type=script&lang=js&"
export * from "./PeerToPeerStatement.vue?vue&type=script&lang=js&"
import style0 from "./PeerToPeerStatement.vue?vue&type=style&index=0&id=3e46c9de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46c9de",
  null
  
)

export default component.exports